import DatePicker from 'react-datepicker';
import './Datepicker.css';
import { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';

function getDateDifferenceInDays(targetDate) {
	const today = new Date();

	// Zero out the time component to only compare dates
	today.setHours(0, 0, 0, 0);
	targetDate.setHours(0, 0, 0, 0);

	const msPerDay = 1000 * 60 * 60 * 24;
	const diffInMs = targetDate - today;
	const diffInDays = Math.round(diffInMs / msPerDay);

	return diffInDays;
}

export const DatePickerComponent = (props) => {
	const { filters, setFilters, index, saveUserInfo, email, isArbitrage, isOutliers, autoOpen = false } = props;
	let displayDate = new Date();


	if (filters?.[index].dateDifference) {
		const currentTime = Date.now();
		const futureTime = currentTime + filters?.[index].dateDifference * 24 * 60 * 60 * 1000;

		const futureDate = new Date(futureTime);
		displayDate = futureDate
	}

	const handleDateChange = async (newDate) => {
		try {
			const copy = JSON.parse(JSON.stringify(filters));
			copy[index].date = newDate.toString();
			copy[index].dateDifference = getDateDifferenceInDays(newDate);
			setFilters(copy);
			if (!isArbitrage && !isOutliers) {
				await saveUserInfo(copy, email);
			}
		} catch (err) {
			console.error('Error updating date:', err);
		}
	};

	return (
		<div className="w-full">
			<div className="mb-4">
				<div className="text-sm font-medium text-gray-300 mb-2">Selected Date</div>
				<div className="px-4 py-2 rounded-full bg-blue-600 text-white font-medium text-sm text-center">
					{displayDate.toLocaleDateString('en-US', { 
						month: 'numeric', 
						day: 'numeric', 
						year: 'numeric' 
					})}
				</div>
			</div>
			<div className="w-full datepicker-wrapper-modal" style={{ overflow: 'visible' }}>
				<DatePicker
					selected={displayDate}
					onChange={(date) => handleDateChange(date)}
					minDate={new Date()}
					inline
					className="w-full"
					wrapperClassName="w-full"
				/>
			</div>
		</div>
	);
};
